import { BackendService } from 'services/BackendService'

export type AdminFile = {
  id: string
  processing_status: string | null
  created_at: string
}

export type AdminUserConversationStat = {
  id: string
  title: string | null
  message_count: number
  updated_at: string
}

export type AdminUserActivity = {
  user_id: string
  videos_uploaded: number
  conversations: AdminUserConversationStat[]
}

export const fetchAdminFiles = async (signal?: AbortSignal): Promise<AdminFile[]> => {
  const result = await BackendService.GET<{ files: AdminFile[] }>('admin/files', { signal })
  return result.files
}

export const fetchAdminUsersActivity = async (signal?: AbortSignal): Promise<AdminUserActivity[]> => {
  const result = await BackendService.GET<{ users: AdminUserActivity[] }>('admin/users-activity', { signal })
  return result.users
}
